import { z } from 'zod';
import { SRequirementsInputsSettings, SResourceRulesSettings } from '@/api/apis/resources/schedule';
import { OrganTypeWithoutKidney } from '@/api/apis/case';
import { SSchedulerSettingsInputsFormType, SSchedulerSettingsRulesFormType } from './types';

export const getDefaultSSchedulerInputsValues = (
  inputsData: SRequirementsInputsSettings,
): SSchedulerSettingsInputsFormType => {
  return inputsData;
};

export const getDefaultSSchedulerRulesValues = (rulesData: SResourceRulesSettings): SSchedulerSettingsRulesFormType => {
  return rulesData;
};

const numberSchema = z.number({ message: 'Required' }).min(0);

const inputsServiceOrganRecordItemSchema = z.object({
  strict: numberSchema,
  flex: numberSchema,
});

// TMDXLP-14091: Kidney inputs are hidden from RS (Surgeons) Settings and the API omits the
// `Kidney` key entirely for regions. Fall back to a zeroed entry (never blocks Save) — it's
// stripped from the payload on submit anyway via `omitKidneyOrganRules`.
export const sSchedulerSettingsInputsFormSchema = z.object({
  perRegions: z.record(z.string(), z.record(z.enum(OrganTypeWithoutKidney), inputsServiceOrganRecordItemSchema)),
});

export const sSchedulerSettingsRulesFormSchema = z.object({
  minNoCallDaysPerPeriod: numberSchema,
  maxNoCallDaysPerPeriod: numberSchema,
  noCallInRow: z.object({
    hardMin: numberSchema,
    recommendedMin: numberSchema,
    recommendedMax: numberSchema,
    hardMax: numberSchema,
  }),
});
